// Public client-side constants. The YouTube API key is exposed to browsers
// regardless of where it lives — make sure your Google Cloud OAuth credential
// has HTTP referrer restrictions for retrogameup.com / localhost.
export const YOUTUBE_API_KEY = import.meta.env.VITE_YOUTUBE_API_KEY
  ?? 'AIzaSyAEzYqreeh8w-nJZB6fLh7G02INi5PxoBE';
export const YOUTUBE_CHANNEL_ID = 'UCT6YAuElq1juoiC9IGrj3vQ';

// Featured/pinned video IDs surfaced at the top of the home page.
export const FEATURED_VIDEO_IDS = ['5wuOWEYyRy0', '1hRfvTRqsxw'];

// "Latest video" highlight on the home page.
export const LATEST_VIDEO_IDS = ['fFRUo26_FBU'];

// Trailer / brand-id video shown in a special slot.
export const TRAILER_VIDEO_IDS = ['qtj_tuTqVIE'];

// Page size for playlistItems / videos batched calls.
export const YT_PAGE_SIZE = 50;

// localStorage key + TTL (2 hours) for the cached video list.
export const VIDEO_CACHE_KEY = 'retrogameup_videos_v9';
export const VIDEO_CACHE_TTL_MS = 7200 * 1000;

// localStorage key for the cookie-consent banner state.
export const COOKIE_CONSENT_KEY = 'retrogameup_cookie_consent';

// Platform → title-alias mapping, used by the title parser to pick a category.
export const PLATFORM_ALIASES = [
  { category: 'playthrough-nes', aliases: ['NES'] },
  { category: 'playthrough-snes', aliases: ['Super NES', 'Super Famicom'] },
  { category: 'playthrough-n64', aliases: ['Nintendo 64'] },
  { category: 'playthrough-atari', aliases: ['Atari 2600'] },
  { category: 'playthrough-intellivision', aliases: ['Intellivision'] },
  { category: 'playthrough-sega-cd', aliases: ['Sega CD'] },
  { category: 'playthrough-sega-32x', aliases: ['Sega 32X'] },
  { category: 'playthrough-sega-genesis', aliases: ['Sega Genesis', 'Mega Drive'] },
  { category: 'playthrough-game-boy', aliases: ['Game Boy'] },
  { category: 'playthrough-sega-master-system', aliases: ['Sega Master System'] },
  { category: 'playthrough-playstation', aliases: ['PlayStation'] },
  { category: 'playthrough-turbografx-16', aliases: ['TurboGrafx-16', 'PC Engine'] },
] as const;

// Doom variants get their own bucket per platform.
export const DOOM_PLATFORMS = [
  { id: 'doom-playthrough-super-nes', aliases: ['Super NES', 'Super Famicom'] },
  { id: 'doom-playthrough-sega-saturn', aliases: ['Sega Saturn'] },
  { id: 'doom-playthrough-sega-32x', aliases: ['Sega 32X'] },
] as const;

// Top-of-page tab strip (mirrors PLATFORM_ALIASES + an "All Playthroughs" head).
export const PLAYTHROUGH_TABS = [
  { id: 'playthrough', label: 'All Playthroughs' },
  { id: 'playthrough-nes', label: 'NES' },
  { id: 'playthrough-snes', label: 'Super Nintendo' },
  { id: 'playthrough-n64', label: 'Nintendo 64' },
  { id: 'playthrough-atari', label: 'Atari 2600' },
  { id: 'playthrough-intellivision', label: 'Intellivision' },
  { id: 'playthrough-sega-cd', label: 'Sega CD' },
  { id: 'playthrough-sega-32x', label: 'Sega 32X' },
  { id: 'playthrough-sega-genesis', label: 'Sega Genesis' },
  { id: 'playthrough-game-boy', label: 'Game Boy' },
  { id: 'playthrough-sega-master-system', label: 'Sega Master System' },
  { id: 'playthrough-playstation', label: 'PlayStation' },
  { id: 'playthrough-turbografx-16', label: 'TurboGrafx-16' },
] as const;
